import { useState } from 'react';
import { CircularLoader, DashboardCard, SelectInput, VerticalChart } from 'components';
import { useAppSelector } from 'hooks/useAppSelector';
import { useVisitsTableGetQuery } from 'store/api/dashboard/dashboardApi';
import * as S from '../../styles';
import { getLastYears } from 'helpers/functions/getLastYears';
import { MenuItem, SelectChangeEvent } from '@mui/material';
import { AppointmentStatus } from 'types/StatusTypes';
import { ucFirst } from 'helpers/functions/toUpperCase';

const AveragePatientVisits = () => {
  const selectedClinic = useAppSelector(state => state.selectedClinic);

  const yearArr = getLastYears();

  const [filterYear, setFilterYear] = useState<number>(yearArr[0]);
  const [filterStatus, setFilterStatus] = useState(AppointmentStatus.ACTIVE);

  const getStat = useVisitsTableGetQuery({
    year: filterYear,
    clinicId: selectedClinic.id,
    status: filterStatus,
  });

  return (
    <S.MainInformation>
      <S.MainContent>
        <S.SubtitleBar>
          <S.SubtitleText>Appointments</S.SubtitleText>
          <S.SubtitleItems>
            <SelectInput
              label="Status"
              value={filterStatus}
              onChange={(e: SelectChangeEvent<unknown>) =>
                setFilterStatus(e.target.value as AppointmentStatus)
              }
            >
              {Object.values(AppointmentStatus).map(status => (
                <MenuItem
                  key={status}
                  value={status}
                  disabled={getStat.isFetching || getStat.isLoading}
                >
                  <S.MenuItemContent>{ucFirst(status)}</S.MenuItemContent>
                </MenuItem>
              ))}
            </SelectInput>
            <SelectInput
              label="Year"
              value={filterYear}
              onChange={(e: SelectChangeEvent<unknown>) =>
                setFilterYear(e.target.value as number)
              }
            >
              {yearArr.map(year => (
                <MenuItem
                  key={year}
                  value={year}
                  disabled={getStat.isFetching || getStat.isLoading}
                >
                  <S.MenuItemContent>{year}</S.MenuItemContent>
                </MenuItem>
              ))}
            </SelectInput>
          </S.SubtitleItems>
        </S.SubtitleBar>
        <S.ChartWrapper>
          <S.Chart>
            {getStat.isLoading || getStat.isFetching ? (
              <CircularLoader color="#0084B1" />
            ) : (
              <VerticalChart
                title="Patient visits"
                labels={getStat.currentData?.graph?.map((item: any) => item.month)}
                records={getStat.currentData?.graph}
              />
            )}
          </S.Chart>
          <S.Items>
            <S.DashboardSmallWrapper>
              <DashboardCard
                $isLoading={getStat.isFetching || getStat.isLoading}
                article="Current Month"
                number={getStat.currentData?.currentMonth}
                $isGray
              />
            </S.DashboardSmallWrapper>
            <S.DashboardSmallWrapper>
              <DashboardCard
                $isLoading={getStat.isFetching || getStat.isLoading}
                article="Current Year"
                number={getStat.currentData?.currentYear}
                $isGray
              />
            </S.DashboardSmallWrapper>
          </S.Items>
        </S.ChartWrapper>
      </S.MainContent>
    </S.MainInformation>
  );
};

export default AveragePatientVisits;
